import { useToast } from '../../utils/hooks';
import { MessageBarList } from '../MessageBarList/MessageBarList';
import { messageBarListStylesToast } from '../MessageBarList/MessageBarList.styles';

export function Toast() {
  const { messages, removeToast } = useToast();
  return (
    <MessageBarList styles={messageBarListStylesToast} autoClose messages={messages} onRemoveMessage={removeToast} />
  );
}
